import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'actions';

class FooterModalButton extends Component {
  openModal = () => {
    const { openModal, modalName } = this.props;
    openModal('Info', { className: 'InfoModal', copyToDisplay: modalName });
  };

  render() {
    return (
      <button
        className="FooterModalButton btn btn-link"
        onClick={this.openModal}
      >
        {this.props.modalName}
      </button>
    );
  }
}

function mapStateToProps(state, props) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      openModal: actions.openModal,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(FooterModalButton);



// WEBPACK FOOTER //
// ./src/Components/Layout/Footer/FooterModalButton.js